export default "__VITE_ASSET__DERZbtTd__"